export default "/assets/d3a0de46386662d4.svg"